import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ContactForm from "../components/ContactForm.jsx";
import '../styles/ContactForm.scss';

export default class ContactUs extends Component {
    render() {
        return (
            <>
                <Helmet>
                    <meta name="description" content="Contact us." />
                    <meta name="keywords" content="contact us" />
                    <title>Contact Us | Benwill Cabinets</title>
                    <link rel="canonical" href="https://www.benwillcabinets.com/contact-us" />
                    <meta property="og:title" content="Contact Us | Benwill Cabinets" />
                    <meta property="og:description" content="" />
                    <meta property="og:url" content="https://www.benwillcabinets.com/contact-us" />
                    <meta name="twitter:description" content="" />
                    <meta name="twitter:title" content="Contact Us | Benwill Cabinets" />
                </Helmet>
                <div id="breadcrumb">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Contact Us</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div id="contact-us">
                    <ContactForm/>
                </div>
            </>
        )
    }
}